import * as yup from 'yup';
import { productNew as TEXT } from 'locales/en';

export const FIELD_NAMES = {
  image: 'image',
  fitPhoto: 'fit_photo',
  name: 'name',
  price: 'price',
  isVatExclusive: 'vat_exclusive',
  vatRate: 'vat_rate',
  description: 'description',
  hasStockLimit: 'has_stock_limit',
  availableStock: 'available_stock',
  autoAccept: 'auto_accept_orders',
  isRequestingInformation: 'request_delivery_details',
  video_embed: 'video_embed',
};

export const defaultValues = {
  [FIELD_NAMES.image]: '',
  [FIELD_NAMES.name]: '',
  [FIELD_NAMES.price]: '',
  [FIELD_NAMES.isVatExclusive]: false,
  [FIELD_NAMES.vatRate]: null,
  [FIELD_NAMES.description]: '',
  [FIELD_NAMES.hasStockLimit]: false,
  [FIELD_NAMES.availableStock]: 0,
  [FIELD_NAMES.autoAccept]: false,
  [FIELD_NAMES.isRequestingInformation]: false,
  [FIELD_NAMES.video_embed]: null,
};

const schema = yup.object().shape({
  [FIELD_NAMES.image]: yup.string().required(TEXT.errors[FIELD_NAMES.image]),
  [FIELD_NAMES.name]: yup.string().required(TEXT.errors[FIELD_NAMES.name]),
  [FIELD_NAMES.price]: yup.string().required(TEXT.errors[FIELD_NAMES.price]),
  [FIELD_NAMES.isVatExclusive]: yup.boolean(),
  [FIELD_NAMES.vatRate]: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .min(0, TEXT.errors.vatRate.min)
    .max(100, TEXT.errors.vatRate.max)
    .nullable(),
  [FIELD_NAMES.description]: yup
    .string()
    .required(TEXT.errors[FIELD_NAMES.description]),
  [FIELD_NAMES.hasStockLimit]: yup.boolean(),
  [FIELD_NAMES.availableStock]: yup.number(),
  [FIELD_NAMES.autoAccept]: yup.boolean(),
  [FIELD_NAMES.isRequestingInformation]: yup.boolean(),
});

export default schema;
